<template>
    <nav class="vue-router-links" aria-label="Reserverings stappen" :class="currentStepClass">
        <template v-if="hasVehicleId">
            <ul class="links-wrapper d-flex justify-content-between">
                <li class="step-one-item">
                    <router-link v-if="! hasLocationId"
                                 disabled
                                 :to="{ name: computedStepOneName, query: { vehicleId: vehicleId } }">
                        {{ translations.rentalPeriodText }}
                    </router-link>
                    <router-link :disabled="!hasLocationId"
                                 v-if="hasLocationId"
                                 :to="{ name: computedStepOneName, query: { vehicleId: vehicleId, locationId: locationId } }">
                        {{ translations.rentalPeriodText }}
                    </router-link>
                </li>
                <li class="step-two-item">
                    <router-link :disabled="!hasLocationId || isAfterPickupTime"
                                 :to="{ name: computedStepTwoName, query: { vehicleId: vehicleId, locationId: locationId } }">
                        Opties
                    </router-link>
                </li>
                <li class="step-three-item">
                    <router-link :disabled="stepThreeDisabled"
                                 :to="{ name: computedStepThreeName, query: { vehicleId: vehicleId, locationId: locationId } }">
                        Je gegevens
                    </router-link>
                </li>
            </ul>
        </template>
    </nav>
</template>

<script>
import {mapGetters} from "vuex";
import translations from "../../mixins/translations";
import moment from "moment";
import router from "../../router";

export default {
    name: "RouterLinks",

    mixins: [translations],

    data() {
        return {
            isBusiness: false
        }
    },

    computed: {
        ...mapGetters([
            'getActiveVehicle',
            'getActiveLocation',
            'getCurrentStep',
            'getStepTwoDisabled',
            'getDepartureDate',
            'isAfterPickupTime',
        ]),

        hasVehicleId() {
            return !lodash.isNil(this.vehicleId);
        },

        hasLocationId() {
            return !lodash.isNil(this.locationId);
        },

        locationId() {
            if (lodash.isNil(this.getActiveLocation)) {
                return null;
            }

            return this.getActiveLocation.id;
        },

        vehicleId() {
            return this.getActiveVehicle.id;
        },

        stepThreeDisabled() {
            return this.getCurrentStep === this.computedStepOneName;
        },

        currentStepClass() {
            if (lodash.isNil(this.getCurrentStep)) {
                return '';
            }

            return `current-${this.getCurrentStep.toLowerCase()}`;
        },

        computedStepOneName() {
            return this.isBusiness ? 'stepOneBusiness' : 'stepOne';
        },
        computedStepTwoName() {
            return this.isBusiness ? 'stepTwoBusiness' : 'stepTwo' ;
        },
        computedStepThreeName() {
            return this.isBusiness ? 'stepThreeBusiness' : 'stepThree';
        },
    },

    created() {
        this.isBusiness = router.currentRoute.meta?.isBusiness ?? false;
    }
}
</script>
